import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateWorkerPermCurrentDetailsRequest extends BaseUpdateRequest {
    previousExperience = '';
}